














import {Component, Prop, Watch} from 'vue-property-decorator'
import Vue from 'vue'

@Component({
    name: "primary-buttons"
})
export default class PrimaryButtons extends Vue {
    @Prop() private confirmable!: boolean | Promise<boolean>

    confirmAvailable: boolean = false
    
    @Watch('confirmable')
    confirmableChanged(confirmable: boolean | Promise<boolean>) {
        window.console.log('confirmableChanged')
        this.handleConfirmable(confirmable)
    }

    onCancel() {
        this.$emit('cancel')
    }

    onConfirm() {
        this.$emit('confirm')
    }

    handleConfirmable(confirmable: boolean | Promise<boolean>) {
       if (confirmable instanceof Promise) {
           confirmable.then(c => { this.confirmAvailable = c })
        } else {
            this.confirmAvailable = confirmable
        }
    }

    mounted() {
        this.handleConfirmable(this.confirmable)
    }

    matomoEvent(label: string) {
      const step = this.$store.getters.activeStepComponent || 'start';
      return `${this.$route.name}_${step};${label}`;
    }

    get hideBackButton() {
        if(this.$store && this.$store.getters && this.$store.getters.currentStepIndexGetter === 0) {
            return true
        }
        return false
    }

    get isLastStep() {
        if(this.$store && this.$store.getters && this.$store.getters.isLastStep) {
            return true
        }
        return false
    }
}
